// This fixes a build issue when running on node
global.self = global;
require('es6-promise').polyfill();
require('fetch-everywhere');
const querystring = require('querystring');
var merge = require('./helpers/merge');
var timeoutPromise = require('./helpers/timeout-promise');
//var URL = 'https://oji7prpx5h.execute-api.us-west-2.amazonaws.com/staging/v1';
var URL = 'https://h24arz68a7.execute-api.us-west-2.amazonaws.com/staging/v1';
//var URL = 'http://localhost:3000/v1';

/**
 * @class BabouJS
 */
function BabouJS() {
    this.api_key = undefined;
    this.URL = URL;
}

/**
 * Sets the babou API Key
 *
 * @function setApiKey
 * @param {String} api_key
 */
function setApiKey(api_key) {
    this.api_key = api_key;
}
BabouJS.prototype.setApiKey = setApiKey;

/**
 * Allows you to manually override the base URL. By default
 * it will be https://wilq5cq0w8.execute-api.us-west-2.amazonaws.com/production/babou
 *
 * @function setURL
 * @param {String} url
 */
function setURL(url) {
    this.URL = url;
}
BabouJS.prototype.setURL = setURL;

/**
 * Allows you to set the API Key and Base URL in one call
 *
 * @function setConfig
 * @param {Object} config
 */
function setConfig(config) {
    if(!config) return this;
    if(config.url) this.setURL(config.url);
    if(config.api_key) this.setApiKey(config.api_key);
    return this;
}
BabouJS.prototype.setConfig = setConfig;

/**
 * By default it will include the preferred_profile of
 * the agent.
 *
 * @function getPreferredAgent
 * @param {Object} agent
 * @param {Object} [options]
 * @param {Boolean} [options.cache=true]
 * @param {Boolean} [options.include_followers=false]
 * @param {Boolean} [options.include_aliases=false]
 * @param {Boolean} [options.include_listings=false]
 * @param {Boolean} [options.include_buys=false]
 * @param {Boolean} [options.include_buying_stats=false]
 * @param {Boolean} [options.include_last_bought=false]
 * @param {Boolean} [options.include_last_listing=false]
 * @param {Number} [options.include_new_listings=0] - Number of new listings to return
 * @param {Number} [options.include_open_houses=0] - Number of listings with open houses to return
 * @param {Number} [options.timeout=10000] - time in MS
 * @param {Number} [options.retries=0] - The number of retries to do before its considered a fail
 */
function getPreferredAgent(agent, options) {
    var defaultOptions = {
        cache: true,
        include_followers: false,
        include_aliases: false,
        include_listings: false,
        include_buys: false,
        include_buying_stats: false,
        include_last_bought: false,
        include_last_listing: false,
        timeout: 10000,
        retries: 0
    }
    options = merge(defaultOptions, options);
    var body = {
        "agent": agent,
        "options": options
    }
    var URL = this.URL;
    var API_KEY = this.api_key;

    return _startFetch();

    /**
     * An internal function used to allow retries
     *
     * @function _startFetch
     * @param {Number} retryCount
     */
    function _startFetch(retryCount) {
        retryCount = retryCount || 0;
        var promise = fetch([URL, '/agent'].join(''), {
            method: 'post',
            headers: {
                'Content-Type': 'application/json',
                'x-api-key': API_KEY
            },
            body: JSON.stringify(body),
        });

        if(!!options.timeout) {
            promise = timeoutPromise(parseInt(options.timeout), new Error('Timed Out!'), promise);
        }

        return promise
        .then(function (response) {
            if (response.status >= 400) {
                throw new Error("Bad response from server");
            }

            return response.json();
        })
        .then(function(jsonObj) {
            if (Object.prototype.hasOwnProperty.call(jsonObj, 'data')) {
                return jsonObj.data;
            }

            return jsonObj;
        })
        .catch(function onError(err) {
            retryCount++;

            if(retryCount > options.retries) {
                throw err;
            } else {
                return _startFetch(retryCount);
            }
        });
    }
}
BabouJS.prototype.getPreferredAgent = getPreferredAgent;


/**
 *
 *
 *
 * @function searchListings
 * @param {Object[]} areas - The areas we want to search listings in
 * @param {Object} [options]
 * @param {Boolean} [options.cache=true]
 * @param {Boolean} [options.include_listings=false]
 * @param {Boolean} [options.include_listing_stats=false]
 * @param {Boolean} [options.include_market_segments=false]
 * @param {Boolean} [options.enhance_listings_with_preferred_vendor_ids=true] - Enhance listings with preferred vendor id
 * @param {Boolean} [options.useSourceZipBlacklist=false] - flag to use source zipcode blacklist
 * @param {String} [options.orderBy=ListingDate:desc] - can sort by 'ListingDate:desc', 'ListPrice:desc', 'ListPrice:asc', or 'OpenHouseDate:asc'
 * @param {Number} [options.limit=48] - number of listings per page
 * @param {Number} [options.skip=0] - go to page that includes this record
 * @param {Number} [options.timeout=10000] - time in MS
 * @param {Number} [options.initial_retry_delay=500] - time in MS, every retry will wait 2x as the last delay
 * @param {Number} [options.include_new_listings=0] - Number of new listings to return
 * @param {Number} [options.include_open_houses=0] - Number of listings with open houses to return
 * @param {('Active'|'Pending'|'Inactive')} [options.active_statuses=null] - The type of normalized status to consider as active for the purpose of the search

 * @param {Number} [options.retries=0] - The number of retries to do before its considered a fail
 */
function searchListings(areas, options) {
    var defaultOptions = {
        cache: true,
        include_listings: false,
        include_listing_stats: true,
        include_market_segments: false,
        enhance_listings_with_preferred_vendor_ids: false,
        include_open_houses: false,
        useSourceZipBlacklist: false,
        orderBy: 'ListingDate:desc',
        limit: 48,
        skip: 0,
        timeout: 10000,
        include_new_listings: 0,
        include_abn_buyers: 0,
        initial_retry_delay: 500,
        retries: 0
    }

    var mergedOptions = merge(defaultOptions, options);
    var body = {
        "areas": areas,
        "options": mergedOptions
    }
    var URL = this.URL;
    var API_KEY = this.api_key;

    return _startFetch();

    /**
     * An internal function used to allow retries
     *
     * @function _startFetch
     * @param {Number} retryCount
     */
    function _startFetch(retryCount) {
        retryCount = retryCount || 0;
        initial_delay = parseInt(mergedOptions.initial_retry_delay) || 500;

        var bodyJson = JSON.stringify(body);
        var promise = fetch([URL, '/listings/search'].join(''), {
            method: 'post',
            headers: {
                'Content-Type': 'application/json',
                'x-api-key': API_KEY
            },
            body: bodyJson,
        });

        // for next retry, we want pickup where we left off
        mergedOptions.cache = true;

        if(!!options.timeout) {
            promise = timeoutPromise(
                parseInt(mergedOptions.timeout),
                new Error('Timed Out!'),
                promise
            );
        }

        return promise
        .then(function (response) {
            if (response.status >= 400) {
                throw new Error("Bad response from server");
            }

            return response.json();
        })
        .catch(function onError(err) {
            retryCount++;

            if(retryCount > mergedOptions.retries) {
                throw err;
            } else {
                // On retries, cache is true so we can pick up
                // where we left off on the last try
                delay = (
                    (initial_delay || 0) *
                    Math.pow(2, retryCount - 1)
                );

                return new Promise(function(resolve, reject){
                    setTimeout(
                        function(){
                            _startFetch(retryCount)
                            .then(resolve)
                            .catch(reject);
                        },
                        delay
                    )
                });
            }
        });
    }
}
BabouJS.prototype.searchListings = searchListings;


/**
 * Fetches listings similar to the address provided
 *
 *
 * @function getSimilarListings
 * @param {Object} [params]
 * @param {String} [params.address] - The address to look for
 * @param {Object} [params.orderBy] - whether to sort using any of the keys available in elasticsearch
 *
*/
function getSimilarListings(params) {
    const options = { params: params };
    return this.callApi('/listings/similar', options);
}
BabouJS.prototype.getSimilarListings = getSimilarListings;


/**
 *
 *
 *
 * @function buyerStats
 * @param {Object[]} areas - The areas we want to search listings in
 * @param {Object} [options]
 * @param {Boolean} [options.cache=true]
 * @param {Number} [options.timeout=10000] - time in MS
 * @param {Number} [options.initial_retry_delay=500] - time in MS, every retry will wait 2x as the last delay
 * @param {Number} [options.retries=0] - The number of retries to do before its considered a fail
 */
function buyerStats(areas, options) {
    var defaultOptions = {
        cache: true,
        timeout: 10000,
        initial_retry_delay: 500,
        retries: 0
    }

    var mergedOptions = merge(defaultOptions, options);
    var body = {
        "areas": areas,
        "options": mergedOptions
    }
    var URL = this.URL;
    var API_KEY = this.api_key;

    return _startFetch();

    /**
     * An internal function used to allow retries
     *
     * @function _startFetch
     * @param {Number} retryCount
     */
    function _startFetch(retryCount) {
        retryCount = retryCount || 0;
        initial_delay = parseInt(mergedOptions.initial_retry_delay) || 500;

        var bodyJson = JSON.stringify(body);
        var promise = fetch([URL, '/sold/stats'].join(''), {
            method: 'post',
            headers: {
                'Content-Type': 'application/json',
                'x-api-key': API_KEY
            },
            body: bodyJson,
        });

        // for next retry, we want pickup where we left off
        mergedOptions.cache = true;

        if(!!options.timeout) {
            promise = timeoutPromise(
                parseInt(mergedOptions.timeout),
                new Error('Timed Out!'),
                promise
            );
        }

        return promise
        .then(function (response) {
            if (response.status >= 400) {
                throw new Error("Bad response from server");
            }

            return response.json();
        })
        .catch(function onError(err) {
            retryCount++;

            if(retryCount > mergedOptions.retries) {
                throw err;
            } else {
                // On retries, cache is true so we can pick up
                // where we left off on the last try
                delay = (
                    (initial_delay || 0) *
                    Math.pow(2, retryCount - 1)
                );

                return new Promise(function(resolve, reject){
                    setTimeout(
                        function(){
                            _startFetch(retryCount)
                            .then(resolve)
                            .catch(reject);
                        },
                        delay
                    )
                });
            }
        });
    }
}
BabouJS.prototype.buyerStats = buyerStats;


/**
 *
 *
 *
 * @function searchAgents
 * @param {String} type - The type of activity we are searching. Can be either 'listing' or 'seller'
 * @param {Object[]} areas - The areas we want to search activity in
 * @param {Object} [options] - Super set of getPreferredAgent
 * @param {Boolean} [options.cache=true] - Flag to use cached data
 * @param {String} [options.orderBy=preferred_profile.name:desc] - pass through to lodash orderBy. Can sort by result before being enhanced by getPreferredAgent options
 * @param {Number} [options.limit=30] - number of agents per page
 * @param {Number} [options.skip=0] - go to page that includes this record
 * @param {Boolean} [options.include_followers=false]
 * @param {Boolean} [options.include_aliases=false]
 * @param {Boolean} [options.include_buying_stats=false]
 * @param {Boolean} [options.include_buys=false]
 * @param {Boolean} [options.include_last_bought=false]
 * @param {Boolean} [options.include_last_listing=false]
 * @param {Number} [options.include_new_listings=0] - Number of new listings to return
 * @param {Number} [options.include_open_houses=0] - Number of listings with open houses to return
 * @param {Number} [options.timeout=10000] - time in MS
 * @param {Number} [options.initial_retry_delay=500] - time in MS, every retry will wait 2x as the last delay
 * @param {Number} [options.retries=0] - The number of retries to do before its considered a fail
 */
function searchAgents(type, areas, options) {
    var defaultOptions = {
        cache: true,
        include_listings: false,
        include_aliases: false,
        include_buying_stats: false,
        include_buys: false,
        include_last_bought: false,
        include_last_listing: false,
        include_open_houses: 0,
        orderBy: 'preferred_profile.name:desc',
        limit: 48,
        skip: 0,
        timeout: 10000,
        include_new_listings: 0,
        include_abn_buyers: 0,
        initial_retry_delay: 500,
        retries: 0
    }

    var mergedOptions = merge(defaultOptions, options);
    var body = {
        "query": {"areas": areas, "type": type},
        "options": mergedOptions
    }
    var URL = this.URL;
    var API_KEY = this.api_key;

    return _startFetch();

    /**
     * An internal function used to allow retries
     *
     * @function _startFetch
     * @param {Number} retryCount
     */
    function _startFetch(retryCount) {
        retryCount = retryCount || 0;
        initial_delay = parseInt(mergedOptions.initial_retry_delay) || 500;

        var bodyJson = JSON.stringify(body);
        var promise = fetch([URL, '/agents/search'].join(''), {
            method: 'post',
            headers: {
                'Content-Type': 'application/json',
                'x-api-key': API_KEY
            },
            body: bodyJson,
        });

        // for next retry, we want pickup where we left off
        mergedOptions.cache = true;

        if(!!options.timeout) {
            promise = timeoutPromise(
                parseInt(mergedOptions.timeout),
                new Error('Timed Out!'),
                promise
            );
        }

        return promise
        .then(function (response) {
            if (response.status >= 400) {
                throw new Error("Bad response from server");
            }

            return response.json();
        })
        .catch(function onError(err) {
            retryCount++;

            if(retryCount > mergedOptions.retries) {
                throw err;
            } else {
                // On retries, cache is true so we can pick up
                // where we left off on the last try
                delay = (
                    (initial_delay || 0) *
                    Math.pow(2, retryCount - 1)
                );

                return new Promise(function(resolve, reject){
                    setTimeout(
                        function(){
                            _startFetch(retryCount)
                            .then(resolve)
                            .catch(reject);
                        },
                        delay
                    )
                });
            }
        });
    }
}
BabouJS.prototype.searchAgents = searchAgents;


/**
 * Allows you to call a babou API using fetch
 *
 *
 * @function callApi
 * @param {String} path - The Babou Path to hit
 * @param {Object} [options] - All fetch options are available to be passed in here
 * @param {Object} [options.params] - fetch does not allow query string params,
 * but we allow that in the options object here

*/
function callApi(path, options) {
    // if '/' wasn't passed in the path, add it to the path
    if(path[0] !== '/') path = '/' + path;

    // add parameters since fetch doesn't do it for us
    if(options.params && Object.keys(options.params).length) {
        var esc = encodeURIComponent;
        var query = Object.keys(options.params)
            .map(function(k) { return esc(k) + '=' + esc(options.params[k]) })
            .join('&');
        path = path + '?' + query;
        delete options.params;
    }

    // set the auth headers
    if(!options.headers) options.headers = {};
    options.headers['Content-Type'] = 'application/json';
    options.headers['x-api-key'] = this.api_key;

    var url = [this.URL, path].join('');
    return fetch(url, options)
    .then(function (response) {
        if (response.status >= 400) {
            throw new Error('Bad response from server');
        }

        return response.json();
    });
};
BabouJS.prototype.callApi = callApi;


/**
 *
 *
 *
 * @function getMasterAgentData
 * @param {Object} agent - The agent we wish to get data on
 * @param {Object} [options] - options
 */
function getMasterAgentData(agent, options) {
    options = options || {};
    var defaultOptions = {
        cache: true,
        timeout: 10000,
        initial_retry_delay: 500,
        retries: 0
    }

    var mergedOptions = merge(defaultOptions, options);
    var body = {
        "agent": agent,
        "options": mergedOptions
    }
    var URL = this.URL;
    var API_KEY = this.api_key;

    return _startFetch();

    /**
     * An internal function used to allow retries
     *
     * @function _startFetch
     * @param {Number} retryCount
     */
    function _startFetch(retryCount) {
        retryCount = retryCount || 0;
        initial_delay = parseInt(mergedOptions.initial_retry_delay) || 500;

        var bodyJson = JSON.stringify(body);
        var promise = fetch([URL, '/master-agent/data'].join(''), {
            method: 'post',
            headers: {
                'Content-Type': 'application/json',
                'x-api-key': API_KEY
            },
            body: bodyJson,
        });

        // for next retry, we want pickup where we left off
        if(!!mergedOptions.timeout) {
            promise = timeoutPromise(
                parseInt(mergedOptions.timeout),
                new Error('Timed Out!'),
                promise
            );
        }

        return promise
        .then(function (response) {
            if (response.status >= 400) {
                throw new Error("Bad response from server");
            }

            return response.json();
        })
        .catch(function onError(err) {
            retryCount++;

            if(retryCount > mergedOptions.retries) {
                throw err;
            } else {
                // On retries, cache is true so we can pick up
                // where we left off on the last try
                delay = (
                    (initial_delay || 0) *
                    Math.pow(2, retryCount - 1)
                );

                return new Promise(function(resolve, reject){
                    setTimeout(
                        function(){
                            _startFetch(retryCount)
                            .then(resolve)
                            .catch(reject);
                        },
                        delay
                    )
                });
            }
        });
    }
}
BabouJS.prototype.getMasterAgentData = getMasterAgentData;


/**
 *
 *
 *
 * @function upsertMasterAgent
 * @param {Object} agent - The agent we wish to get data on
 * @param {Object} [options] - options
 * @param {Object} [options.calculateStats] - recalculate agent statistics
 */
function upsertMasterAgent(agent, options) {
    var defaultOptions = {
        cache: true,
        timeout: 10000,
        initial_retry_delay: 500,
        retries: 0
    }

    var mergedOptions = merge(defaultOptions, options);
    var body = {
        "agent": agent,
        "options": mergedOptions
    }
    var URL = this.URL;
    var API_KEY = this.api_key;

    return _startFetch();

    /**
     * An internal function used to allow retries
     *
     * @function _startFetch
     * @param {Number} retryCount
     */
    function _startFetch(retryCount) {
        retryCount = retryCount || 0;
        initial_delay = parseInt(mergedOptions.initial_retry_delay) || 500;

        var bodyJson = JSON.stringify(body);
        var promise = fetch([URL, '/master-agent'].join(''), {
            method: 'post',
            headers: {
                'Content-Type': 'application/json',
                'x-api-key': API_KEY
            },
            body: bodyJson,
        });

        // for next retry, we want pickup where we left off
        if(!!mergedOptions.timeout) {
            promise = timeoutPromise(
                parseInt(mergedOptions.timeout),
                new Error('Timed Out!'),
                promise
            );
        }

        return promise
        .then(function (response) {
            if (response.status >= 400) {
                throw new Error("Bad response from server");
            }

            return response.json();
        })
        .catch(function onError(err) {
            retryCount++;

            if(retryCount > mergedOptions.retries) {
                throw err;
            } else {
                // On retries, cache is true so we can pick up
                // where we left off on the last try
                delay = (
                    (initial_delay || 0) *
                    Math.pow(2, retryCount - 1)
                );

                return new Promise(function(resolve, reject){
                    setTimeout(
                        function(){
                            _startFetch(retryCount)
                            .then(resolve)
                            .catch(reject);
                        },
                        delay
                    )
                });
            }
        });
    }
}
BabouJS.prototype.upsertMasterAgent = upsertMasterAgent;


/**
 *
 *
 *
 * @function setMasterAgent
 * @param {Object} agent - The agent we wish to get data on
 * @param {Object} [options] - options
 */
function setMasterAgent(id, agent, options) {
    var defaultOptions = {
        cache: true,
        timeout: 10000,
        initial_retry_delay: 500,
        retries: 0
    }

    var mergedOptions = merge(defaultOptions, options);
    var body = agent;

    var URL = this.URL;
    var API_KEY = this.api_key;

    return _startFetch();

    /**
     * An internal function used to allow retries
     *
     * @function _startFetch
     * @param {Number} retryCount
     */
    function _startFetch(retryCount) {
        retryCount = retryCount || 0;
        initial_delay = parseInt(mergedOptions.initial_retry_delay) || 500;

        var bodyJson = JSON.stringify(body);
        var promise = fetch([URL, '/master-agent/', id].join(''), {
            method: 'put',
            headers: {
                'Content-Type': 'application/json',
                'x-api-key': API_KEY
            },
            body: bodyJson,
        });

        // for next retry, we want pickup where we left off
        if(!!mergedOptions.timeout) {
            promise = timeoutPromise(
                parseInt(mergedOptions.timeout),
                new Error('Timed Out!'),
                promise
            );
        }

        return promise
        .then(function (response) {
            console.log("response:", response);
            if (response.status >= 400) {
                throw new Error("Bad response from server");
            }

            return response.json();
        })
        .catch(function onError(err) {
            retryCount++;

            if(retryCount > mergedOptions.retries) {
                throw err;
            } else {
                // On retries, cache is true so we can pick up
                // where we left off on the last try
                delay = (
                    (initial_delay || 0) *
                    Math.pow(2, retryCount - 1)
                );

                return new Promise(function(resolve, reject){
                    setTimeout(
                        function(){
                            _startFetch(retryCount)
                            .then(resolve)
                            .catch(reject);
                        },
                        delay
                    )
                });
            }
        });
    }
}
BabouJS.prototype.setMasterAgent = setMasterAgent;


/**
 *
 *
 *
 * @function updateMasterAgentStatsByIds
 * @param {[Object]} masterAgentIds - ids of records in our master agent collection
 * @param {Object} [options] - options
 */
function updateMasterAgentStatsByIds(masterAgentIds, options) {
    var defaultOptions = {
        timeout: 30000,
        initial_retry_delay: 500,
        retries: 0
    }

    var mergedOptions = merge(defaultOptions, options);
    var body = {
        "ids": masterAgentIds,
        "options": mergedOptions
    }
    var URL = this.URL;
    var API_KEY = this.api_key;

    return _startFetch();

    /**
     * An internal function used to allow retries
     *
     * @function _startFetch
     * @param {Number} retryCount
     */
    function _startFetch(retryCount) {
        retryCount = retryCount || 0;
        initial_delay = parseInt(mergedOptions.initial_retry_delay) || 500;

        var bodyJson = JSON.stringify(body);
        var promise = fetch([URL, '/master-agent/update_stats'].join(''), {
            method: 'post',
            headers: {
                'Content-Type': 'application/json',
                'x-api-key': API_KEY
            },
            body: bodyJson,
        });

        // for next retry, we want pickup where we left off
        if(!!mergedOptions.timeout) {
            promise = timeoutPromise(
                parseInt(mergedOptions.timeout),
                new Error('Timed Out!'),
                promise
            );
        }

        return promise
        .then(function (response) {
            if (response.status >= 400) {
                throw new Error("Bad response from server");
            }

            return response.json();
        })
        .catch(function onError(err) {
            retryCount++;

            if(retryCount > mergedOptions.retries) {
                throw err;
            } else {
                // On retries, cache is true so we can pick up
                // where we left off on the last try
                delay = (
                    (initial_delay || 0) *
                    Math.pow(2, retryCount - 1)
                );

                return new Promise(function(resolve, reject){
                    setTimeout(
                        function(){
                            _startFetch(retryCount)
                            .then(resolve)
                            .catch(reject);
                        },
                        delay
                    )
                });
            }
        });
    }
}
BabouJS.prototype.updateMasterAgentStatsByIds = updateMasterAgentStatsByIds;


/**
 *
 *
 *
 * @function getOutdatedStatsMasterAgentIds
 * @param {Object} limit - number of ids of master agent records with outdated stats
 * @param {Object} [options] - options
 */
function getOutdatedStatsMasterAgentIds(limit, options) {
    limit = limit != null ? limit : 20;
    var defaultOptions = {
        timeout: 10000,
        initial_retry_delay: 500,
        retries: 0
    }

    var mergedOptions = merge(defaultOptions, options);
    var URL = this.URL;
    var API_KEY = this.api_key;

    return _startFetch();

    /**
     * An internal function used to allow retries
     *
     * @function _startFetch
     * @param {Number} retryCount
     */
    function _startFetch(retryCount) {
        retryCount = retryCount || 0;
        initial_delay = parseInt(mergedOptions.initial_retry_delay) || 500;

        var promise = fetch([URL, '/master-agent/old_stats?limit=', limit].join(''), {
            method: 'get',
            headers: {
                'Content-Type': 'application/json',
                'x-api-key': API_KEY
            }
        });

        // for next retry, we want pickup where we left off
        if(!!mergedOptions.timeout) {
            promise = timeoutPromise(
                parseInt(mergedOptions.timeout),
                new Error('Timed Out!'),
                promise
            );
        }

        return promise
        .then(function (response) {
            if (response.status >= 400) {
                throw new Error("Bad response from server");
            }

            return response.json();
        })
        .catch(function onError(err) {
            retryCount++;

            if(retryCount > mergedOptions.retries) {
                throw err;
            } else {
                // On retries, cache is true so we can pick up
                // where we left off on the last try
                delay = (
                    (initial_delay || 0) *
                    Math.pow(2, retryCount - 1)
                );

                return new Promise(function(resolve, reject){
                    setTimeout(
                        function(){
                            _startFetch(retryCount)
                            .then(resolve)
                            .catch(reject);
                        },
                        delay
                    )
                });
            }
        });
    }
}
BabouJS.prototype.getOutdatedStatsMasterAgentIds = getOutdatedStatsMasterAgentIds;


/**
 *
 *
 *
 * @function getMasterAgentRecordById
 * @param {Object} id - id of a master agent record
 * @param {Object} [options] - options
 */
function getMasterAgentRecordById(id, options) {
    var defaultOptions = {
        timeout: 10000,
        initial_retry_delay: 500,
        retries: 0
    }

    var mergedOptions = merge(defaultOptions, options);
    var URL = this.URL;
    var API_KEY = this.api_key;

    return _startFetch();

    /**
     * An internal function used to allow retries
     *
     * @function _startFetch
     * @param {Number} retryCount
     */
    function _startFetch(retryCount) {
        retryCount = retryCount || 0;
        initial_delay = parseInt(mergedOptions.initial_retry_delay) || 500;

        var promise = fetch([URL, '/master-agent/', id].join(''), {
            method: 'get',
            headers: {
                'Content-Type': 'application/json',
                'x-api-key': API_KEY
            }
        });

        // for next retry, we want pickup where we left off
        if(!!mergedOptions.timeout) {
            promise = timeoutPromise(
                parseInt(mergedOptions.timeout),
                new Error('Timed Out!'),
                promise
            );
        }

        return promise
        .then(function (response) {
            if (response.status >= 400) {
                throw new Error("Bad response from server");
            }

            return response.json();
        })
        .catch(function onError(err) {
            retryCount++;

            if(retryCount > mergedOptions.retries) {
                throw err;
            } else {
                // On retries, cache is true so we can pick up
                // where we left off on the last try
                delay = (
                    (initial_delay || 0) *
                    Math.pow(2, retryCount - 1)
                );

                return new Promise(function(resolve, reject){
                    setTimeout(
                        function(){
                            _startFetch(retryCount)
                            .then(resolve)
                            .catch(reject);
                        },
                        delay
                    )
                });
            }
        });
    }
}
BabouJS.prototype.getMasterAgentRecordById = getMasterAgentRecordById;


/**
 *
 *
 *
 * @function updateMasterAgentStats
 * @param {Object} id - id of a master agent record to be update
 * @param {Object} [options] - options
 */
function updateMasterAgentStats(id, options) {
    var defaultOptions = {
        timeout: 10000,
        initial_retry_delay: 500,
        retries: 0
    }

    var mergedOptions = merge(defaultOptions, options);
    var URL = this.URL;
    var API_KEY = this.api_key;

    return _startFetch();

    /**
     * An internal function used to allow retries
     *
     * @function _startFetch
     * @param {Number} retryCount
     */
    function _startFetch(retryCount) {
        retryCount = retryCount || 0;
        initial_delay = parseInt(mergedOptions.initial_retry_delay) || 500;

        var promise = fetch([URL, '/master-agent/', id, '/update_stats'].join(''), {
            method: 'get',
            headers: {
                'Content-Type': 'application/json',
                'x-api-key': API_KEY
            }
        });

        // for next retry, we want pickup where we left off
        if(!!mergedOptions.timeout) {
            promise = timeoutPromise(
                parseInt(mergedOptions.timeout),
                new Error('Timed Out!'),
                promise
            );
        }

        return promise
        .then(function (response) {
            if (response.status >= 400) {
                throw new Error("Bad response from server");
            }

            return response.json();
        })
        .catch(function onError(err) {
            retryCount++;

            if(retryCount > mergedOptions.retries) {
                throw err;
            } else {
                // On retries, cache is true so we can pick up
                // where we left off on the last try
                delay = (
                    (initial_delay || 0) *
                    Math.pow(2, retryCount - 1)
                );

                return new Promise(function(resolve, reject){
                    setTimeout(
                        function(){
                            _startFetch(retryCount)
                            .then(resolve)
                            .catch(reject);
                        },
                        delay
                    )
                });
            }
        });
    }
}
BabouJS.prototype.updateMasterAgentStats = updateMasterAgentStats;

/**
 *
 *
 *
 * @function searchMasterAgent
 * @param {Object} params - params to search master agent profiles
 * @param {String} [params.email] - email to search by
 * @param {String} [params.license_number] - realtor license number to search by
 * @param {String} [params.portal_user_id] - portal user id to search by
 * @param {String} [params.company] - company (use with state) to search by
 * @param {String} [params.state] - state (use with company) to search by
 * @param {String} [params.phone_number] - realtor phone number to search by
 * @param {String} [params.first_name] - realtor first name to search by
 * @param {String} [params.last_name] - realtor last name to search by

 * @param {Object} [options] - options
 */
function searchMasterAgent(params, options) {
    var defaultOptions = {
        cache: true,
        timeout: 10000,
        initial_retry_delay: 500,
        retries: 0
    }

    var mergedOptions = merge(defaultOptions, options);
    var queryS = querystring.stringify(params);
    var URL = this.URL;
    var API_KEY = this.api_key;

    return _startFetch();

    /**
     * An internal function used to allow retries
     *
     * @function _startFetch
     * @param {Number} retryCount
     */
    function _startFetch(retryCount) {
        retryCount = retryCount || 0;
        initial_delay = parseInt(mergedOptions.initial_retry_delay) || 500;

        var promise = fetch([URL, '/master-agent/search?', queryS].join(''), {
            method: 'get',
            headers: {
                'Content-Type': 'application/json',
                'x-api-key': API_KEY
            }
        });

        // for next retry, we want pickup where we left off
        if(!!mergedOptions.timeout) {
            promise = timeoutPromise(
                parseInt(mergedOptions.timeout),
                new Error('Timed Out!'),
                promise
            );
        }

        return promise
        .then(function (response) {
            if (response.status >= 400) {
                throw new Error("Bad response from server");
            }

            return response.json();
        })
        .catch(function onError(err) {
            retryCount++;

            if(retryCount > mergedOptions.retries) {
                throw err;
            } else {
                // On retries, cache is true so we can pick up
                // where we left off on the last try
                delay = (
                    (initial_delay || 0) *
                    Math.pow(2, retryCount - 1)
                );

                return new Promise(function(resolve, reject){
                    setTimeout(
                        function(){
                            _startFetch(retryCount)
                            .then(resolve)
                            .catch(reject);
                        },
                        delay
                    )
                });
            }
        });
    }
}
BabouJS.prototype.searchMasterAgent= searchMasterAgent;



/**
 *
 *
 *
 * @function getAgentReferralSuggestions
 * @param {Object} [query] - An object to pass query params into
 * @param {Array} [query.portal_user_ids] - A list of portal user ids
 * @param {Array} [query.suggestion_ids] - A list of suggestion ids
 * @param {Array} [query.suggested_agent_emails] - A list of suggested agent emails
 * @param {Object} [options] - options
 */
function getAgentReferralSuggestions(query, options) {
    var defaultOptions = {
        cache: true,
        timeout: 10000,
        initial_retry_delay: 500,
        retries: 0
    }

    // legacy API: query used to be only portal_user_ids (string or array), so treat it as such
    // if query is a string, split it by , so we convert to an array
    if(typeof query === 'string') {
        const portal_user_ids = query.split(',').map(function (item) {
            return item.trim();
        });
        query = { portal_user_ids: portal_user_ids };
    } else if(Array.isArray(query)) {
        const portal_user_ids = query;
        query = { portal_user_ids: portal_user_ids };
    }

    options = merge(defaultOptions, options);
    var body = {
        query: query,
        options: options,
    }

    var URL = this.URL;
    var API_KEY = this.api_key;

    return _startFetch();

    /**
     * An internal function used to allow retries
     *
     * @function _startFetch
     * @param {Number} retryCount
     */
    function _startFetch(retryCount) {
        retryCount = retryCount || 0;
        var promise = fetch([URL, '/agent/agent-referral-suggestions'].join(''), {
            method: 'post',
            headers: {
                'Content-Type': 'application/json',
                'x-api-key': API_KEY
            },
            body: JSON.stringify(body),
        });

        if(!!options.timeout) {
            promise = timeoutPromise(parseInt(options.timeout), new Error('Timed Out!'), promise);
        }

        return promise
        .then(function (response) {
            if (response.status >= 400) {
                throw new Error("Bad response from server");
            }

            return response.json();
        })
        .then(function(jsonObj) {
            return jsonObj;
        })
        .catch(function onError(err) {
            retryCount++;

            if(retryCount > options.retries) {
                throw err;
            } else {
                return _startFetch(retryCount);
            }
        });
    }
}
BabouJS.prototype.getAgentReferralSuggestions = getAgentReferralSuggestions;



/**
 *
 *
 *
 * @function excludeAgentReferralSuggestions
 * @param {Array} [exclusions] - A list of object of portal user ids and emails
 *                               to exclude for the user
 * @param {Array.Object} [portal_user_id] - The portal_user_id to add the exclusion to
 * @param {Array.Object} [suggested_agent_email] - The email to exclude for the portal user id
 * @param {Object} [options] - options
 */
function excludeAgentReferralSuggestions(exclusions, options) {
    var defaultOptions = {
        cache: true,
        timeout: 10000,
        initial_retry_delay: 500,
        retries: 0
    }

    options = merge(defaultOptions, options);
    var body = {
        exclusions: exclusions,
        options: options,
    }

    var URL = this.URL;
    var API_KEY = this.api_key;

    return _startFetch();

    /**
     * An internal function used to allow retries
     *
     * @function _startFetch
     * @param {Number} retryCount
     */
    function _startFetch(retryCount) {
        retryCount = retryCount || 0;
        var promise = fetch([URL, '/agent/exclude-agent-referral-suggestions'].join(''), {
            method: 'post',
            headers: {
                'Content-Type': 'application/json',
                'x-api-key': API_KEY
            },
            body: JSON.stringify(body),
        });

        if (!!options.timeout) {
            promise = timeoutPromise(parseInt(options.timeout), new Error('Timed Out!'), promise);
        }

        return promise
            .then(function (response) {
                if (response.status >= 400) {
                    throw new Error("Bad response from server");
                }

                return response.json();
            })
            .then(function (jsonObj) {
                return jsonObj;
            })
            .catch(function onError(err) {
                retryCount++;

                if (retryCount > options.retries) {
                    throw err;
                } else {
                    return _startFetch(retryCount);
                }
            });
    }
}
BabouJS.prototype.excludeAgentReferralSuggestions = excludeAgentReferralSuggestions;



/**
 * Gets the raw listing straight from the source database
 *
 *
 * @function getRawListing
 * @param {String} [source] - The source for the listing: wolfnet/rets
 * @param {listingId} [listingId] - The listingId of the listing to fetch
 * @param {Object} [options] - options
 */
function getRawListing(source, listingId, options) {
    var defaultOptions = {
        cache: true,
        timeout: 10000,
        initial_retry_delay: 500,
        retries: 0
    }

    options = merge(defaultOptions, options);

    var URL = [this.URL, 'listings/raw', source, listingId].join('/');
    var API_KEY = this.api_key;

    return _startFetch();

    /**
     * An internal function used to allow retries
     *
     * @function _startFetch
     * @param {Number} retryCount
     */
    function _startFetch(retryCount) {
        retryCount = retryCount || 0;
        var promise = fetch(URL, {
            method: 'get',
            headers: {
                'Content-Type': 'application/json',
                'x-api-key': API_KEY
            },
        });

        if (!!options.timeout) {
            promise = timeoutPromise(parseInt(options.timeout), new Error('Timed Out!'), promise);
        }

        return promise
            .then(function (response) {
                if (response.status >= 400) {
                    throw new Error("Bad response from server");
                }

                return response.json();
            })
            .then(function (jsonObj) {
                return jsonObj;
            })
            .catch(function onError(err) {
                retryCount++;

                if (retryCount > options.retries) {
                    throw err;
                } else {
                    return _startFetch(retryCount);
                }
            });
    }
}
BabouJS.prototype.getRawListing = getRawListing;



/**
 *
 *
 *
 * @function searchAgentOffice
 * @param {Object[]} areas - The areas we want to search agent office located in. Only support zipcode and city
 * @param {Object} [options]
 * @param {Number} [options.timeout=10000] - time in MS
 * @param {Number} [options.initial_retry_delay=500] - time in MS, every retry will wait 2x as the last delay
 * @param {Number} [options.retries=0] - The number of retries to do before its considered a fail
 */
function searchAgentOffice(areas, options) {
    var defaultOptions = {
        timeout: 10000,
        initial_retry_delay: 500,
        retries: 0
    }

    var mergedOptions = merge(defaultOptions, options);
    var body = {
        "query": { areas: areas },
        "options": mergedOptions
    }
    var URL = this.URL;
    var API_KEY = this.api_key;

    return _startFetch();

    /**
     * An internal function used to allow retries
     *
     * @function _startFetch
     * @param {Number} retryCount
     */
    function _startFetch(retryCount) {
        retryCount = retryCount || 0;
        initial_delay = parseInt(mergedOptions.initial_retry_delay) || 500;

        var bodyJson = JSON.stringify(body);
        var promise = fetch([URL, '/agent-office/searchByArea'].join(''), {
            method: 'post',
            headers: {
                'Content-Type': 'application/json',
                'x-api-key': API_KEY
            },
            body: bodyJson,
        });

        // for next retry, we want pickup where we left off
        mergedOptions.cache = true;

        if(!!options.timeout) {
            promise = timeoutPromise(
                parseInt(mergedOptions.timeout),
                new Error('Timed Out!'),
                promise
            );
        }

        return promise
        .then(function (response) {
            if (response.status >= 400) {
                throw new Error("Bad response from server");
            }

            return response.json();
        })
        .catch(function onError(err) {
            retryCount++;

            if(retryCount > mergedOptions.retries) {
                throw err;
            } else {
                // On retries, cache is true so we can pick up
                // where we left off on the last try
                delay = (
                    (initial_delay || 0) *
                    Math.pow(2, retryCount - 1)
                );

                return new Promise(function(resolve, reject){
                    setTimeout(
                        function(){
                            _startFetch(retryCount)
                            .then(resolve)
                            .catch(reject);
                        },
                        delay
                    )
                });
            }
        });
    }
}
BabouJS.prototype.searchAgentOffice = searchAgentOffice;



/**
 *
 *
 *
 * @function refreshAllAirtableCaches
 * @param {Object} [options]
 * @param {Number} [options.timeout=10000] - time in MS
 * @param {Number} [options.initial_retry_delay=500] - time in MS, every retry will wait 2x as the last delay
 * @param {Number} [options.retries=0] - The number of retries to do before its considered a fail
 */
function refreshAllAirtableCaches(options) {
    var defaultOptions = {
        timeout: 20000,
        initial_retry_delay: 500,
        retries: 0
    }

    var mergedOptions = merge(defaultOptions, options);
    var URL = this.URL;
    var API_KEY = this.api_key;

    return _startFetch();

    /**
     * An internal function used to allow retries
     *
     * @function _startFetch
     * @param {Number} retryCount
     */
    function _startFetch(retryCount) {
        retryCount = retryCount || 0;
        initial_delay = parseInt(mergedOptions.initial_retry_delay) || 500;

        var promise = fetch([URL, '/cache/refreshAirTableData'].join(''), {
            method: 'get',
            headers: {
                'Content-Type': 'application/json',
                'x-api-key': API_KEY
            }
        });

        // for next retry, we want pickup where we left off
        if(!!mergedOptions.timeout) {
            promise = timeoutPromise(
                parseInt(mergedOptions.timeout),
                new Error('Timed Out!'),
                promise
            );
        }

        return promise
        .then(function (response) {
            if (response.status >= 400) {
                throw new Error("Bad response from server");
            }

            return response.json();
        })
        .catch(function onError(err) {
            retryCount++;

            if(retryCount > mergedOptions.retries) {
                throw err;
            } else {
                // On retries, cache is true so we can pick up
                // where we left off on the last try
                delay = (
                    (initial_delay || 0) *
                    Math.pow(2, retryCount - 1)
                );

                return new Promise(function(resolve, reject){
                    setTimeout(
                        function(){
                            _startFetch(retryCount)
                            .then(resolve)
                            .catch(reject);
                        },
                        delay
                    )
                });
            }
        });
    }
}
BabouJS.prototype.refreshAllAirtableCaches = refreshAllAirtableCaches;



/**
 *
 *
 *
 * @function refreshAirtableData
 * @param {String} airtableService=["blacklistedSourceZipcode", "propertyTypeValue", "listingStatus"] - Airtable service data to be refresh. Must specify one of the three supported service.
 * @param {Object} [options]
 * @param {Number} [options.timeout=10000] - time in MS
 * @param {Number} [options.initial_retry_delay=500] - time in MS, every retry will wait 2x as the last delay
 * @param {Number} [options.retries=0] - The number of retries to do before its considered a fail
 */
function refreshAirtableData(airtableService, options) {
    var defaultOptions = {
        timeout: 20000,
        initial_retry_delay: 500,
        retries: 0
    }

    var mergedOptions = merge(defaultOptions, options);
    var URL = this.URL;
    var API_KEY = this.api_key;

    return _startFetch();

    /**
     * An internal function used to allow retries
     *
     * @function _startFetch
     * @param {Number} retryCount
     */
    function _startFetch(retryCount) {
        retryCount = retryCount || 0;
        initial_delay = parseInt(mergedOptions.initial_retry_delay) || 500;

        var promise = fetch([URL, '/airtable/', airtableService, '/refresh'].join(''), {
            method: 'get',
            headers: {
                'Content-Type': 'application/json',
                'x-api-key': API_KEY
            }
        });

        // for next retry, we want pickup where we left off
        if(!!mergedOptions.timeout) {
            promise = timeoutPromise(
                parseInt(mergedOptions.timeout),
                new Error('Timed Out!'),
                promise
            );
        }

        return promise
        .then(function (response) {
            if (response.status >= 400) {
                throw new Error("Bad response from server");
            }

            return response.json();
        })
        .catch(function onError(err) {
            retryCount++;

            if(retryCount > mergedOptions.retries) {
                throw err;
            } else {
                // On retries, cache is true so we can pick up
                // where we left off on the last try
                delay = (
                    (initial_delay || 0) *
                    Math.pow(2, retryCount - 1)
                );

                return new Promise(function(resolve, reject){
                    setTimeout(
                        function(){
                            _startFetch(retryCount)
                            .then(resolve)
                            .catch(reject);
                        },
                        delay
                    )
                });
            }
        });
    }
}
BabouJS.prototype.refreshAirtableData = refreshAirtableData;



/**
 *
 *
 *
 * @function getAirtableData
 * @param {String} geteService=["blacklistedSourceZipcode", "propertyTypeValue", "listingStatus"] - Airtable service data to be refresh. Must specify one of the three supported service.
 * @param {Object} [options]
 * @param {Number} [options.noCache=0] - if noCache is 1, service will retrieve fresh data from airtable.
 * @param {Number} [options.timeout=10000] - time in MS
 * @param {Number} [options.initial_retry_delay=500] - time in MS, every retry will wait 2x as the last delay
 * @param {Number} [options.retries=0] - The number of retries to do before its considered a fail
 */
function getAirtableData(airtableService, options) {
    var defaultOptions = {
        timeout: 20000,
        initial_retry_delay: 500,
        retries: 0
    }

    var mergedOptions = merge(defaultOptions, options);
    var URL = this.URL;
    var API_KEY = this.api_key;
    var NO_CACHE = options && options.noCache ? options.noCache : 0;
    var SERVICE_URL = [URL, '/airtable/', airtableService, '?noCache=', NO_CACHE].join('');
    console.log(`SERVICE_URL: '${SERVICE_URL}'`);

    return _startFetch();

    /**
     * An internal function used to allow retries
     *
     * @function _startFetch
     * @param {Number} retryCount
     */
    function _startFetch(retryCount) {
        retryCount = retryCount || 0;
        initial_delay = parseInt(mergedOptions.initial_retry_delay) || 500;


        var promise = fetch(SERVICE_URL, {
            method: 'get',
            headers: {
                'Content-Type': 'application/json',
                'x-api-key': API_KEY
            }
        });

        // for next retry, we want pickup where we left off
        if(!!mergedOptions.timeout) {
            promise = timeoutPromise(
                parseInt(mergedOptions.timeout),
                new Error('Timed Out!'),
                promise
            );
        }

        return promise
        .then(function (response) {
            if (response.status >= 400) {
                throw new Error("Bad response from server");
            }

            return response.json();
        })
        .catch(function onError(err) {
            retryCount++;

            if(retryCount > mergedOptions.retries) {
                throw err;
            } else {
                // On retries, cache is true so we can pick up
                // where we left off on the last try
                delay = (
                    (initial_delay || 0) *
                    Math.pow(2, retryCount - 1)
                );

                return new Promise(function(resolve, reject){
                    setTimeout(
                        function(){
                            _startFetch(retryCount)
                            .then(resolve)
                            .catch(reject);
                        },
                        delay
                    )
                });
            }
        });
    }
}
BabouJS.prototype.getAirtableData = getAirtableData;


/**
 * Gets the AVM data for a list of IDs
 *
 *
 * @function getAvm
 * @param {String[]} avmIds - An array of AVM IDs to fetch data for. ID depends on the source (attom ID for now)
 * @param {Object} [params] - params
 * @param {Number} [params.limit] - Number of records to fetch [defaults to 100]
 * @param {Number} [params.orderBy] - The sort order of the records [defaults to createdate desc]
 * @param {Object} [options] - Other babou options
 */
function getAvm(avmIds, params, options) {
    var defaultOptions = {
        timeout: 10000,
        initial_retry_delay: 500,
        retries: 0,
    };
    const qsParams = {
        limit: params.limit || 100,
        orderBy: params.orderBy || 'createdate desc',
    };

    var queryS = querystring.stringify(qsParams);

    options = merge(defaultOptions, options || {});

    var URL = [this.URL, 'avm', avmIds.join(',')].join('/');
    URL = URL + '?' + queryS;
    var API_KEY = this.api_key;

    return _startFetch();

    /**
     * An internal function used to allow retries
     *
     * @function _startFetch
     * @param {Number} retryCount
     */
    function _startFetch(retryCount) {
        retryCount = retryCount || 0;
        var promise = fetch(URL, {
            method: 'get',
            headers: {
                'Content-Type': 'application/json',
                'x-api-key': API_KEY
            },
            params: {
                limit: options.limit,
                orderBy: options.orderBy,
            }
        });

        if (!!options.timeout) {
            promise = timeoutPromise(parseInt(options.timeout), new Error('Timed Out!'), promise);
        }

        return promise
            .then(function (response) {
                if (response.status >= 400) {
                    throw new Error("Bad response from server");
                }

                return response.json();
            })
            .then(function (jsonObj) {
                return jsonObj;
            })
            .catch(function onError(err) {
                retryCount++;

                if (retryCount > options.retries) {
                    throw err;
                } else {
                    return _startFetch(retryCount);
                }
            });
    }
}
BabouJS.prototype.getAvm = getAvm;


module.exports = new BabouJS();
